import { C as t } from "./component-C-rYG68G.js";
import { D as o, d as l } from "./events-CnaEWcY_.js";
import { d as a } from "./utilities-BYG85iVY.js";
class e extends t {
  requiredRefs = ["dialog"];
  static openCount = 0;
  static savedScrollY = 0;
  #s = !1;
  connectedCallback() {
    (super.connectedCallback(),
      this.refs.dialog.addEventListener("click", this.#i),
      this.refs.dialog.addEventListener("cancel", this.#t));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      this.refs.dialog.removeEventListener("click", this.#i),
      this.refs.dialog.removeEventListener("cancel", this.#t),
      this.refs.dialog.open && this.#e(!1));
  }
  #i = (s) => {
    s.target === this.refs.dialog && this.closeDialog();
  };
  #t = (s) => {
    (s.preventDefault(), this.closeDialog());
  };
  #e(s) {
    if (s === this.#s) return;
    this.#s = s;
    const i = document.body;
    s
      ? (e.openCount === 0 &&
          ((e.savedScrollY = window.scrollY),
          (i.style.position = "fixed"),
          (i.style.top = `-${e.savedScrollY}px`),
          (i.style.width = "100%"),
          (i.style.overflow = "hidden")),
        e.openCount++)
      : (e.openCount--,
        e.openCount <= 0 &&
          ((e.openCount = 0),
          (i.style.position = ""),
          (i.style.top = ""),
          (i.style.width = ""),
          (i.style.overflow = ""),
          window.scrollTo({ top: e.savedScrollY, left: 0, behavior: "instant" })));
  }
  showDialog() {
    if (this.refs.dialog.open) {
      (this.refs.dialog.classList.remove("dialog-closing"), this.#e(!0));
      return;
    }
    (this.refs.dialog.classList.remove("dialog-closing"),
      this.refs.dialog.showModal(),
      this.#e(!0),
      this.dispatchEvent(new o()));
  }
  closeDialog() {
    return this.refs.dialog.open
      ? (this.refs.dialog.classList.add("dialog-closing"),
        this.#e(!1),
        new Promise((s) => {
          this.refs.dialog.addEventListener(
            "animationend",
            () => {
              (this.refs.dialog.close(),
                this.refs.dialog.classList.remove("dialog-closing"),
                this.dispatchEvent(new l()),
                s());
            },
            { once: !0 }
          );
        }))
      : Promise.resolve();
  }
  toggleDialog() {
    return this.refs.dialog.open ? this.closeDialog() : (this.showDialog(), Promise.resolve());
  }
}
a("dialog-component", e);
const c = Object.freeze(
  Object.defineProperty({ __proto__: null, DialogComponent: e }, Symbol.toStringTag, {
    value: "Module",
  })
);
export { e as D, c as d };
